import { FC } from "react";
import { EquipmentType } from "../../app/types/ProposalTypes";

interface EquipmentsReceiptProps {
  equipment: EquipmentType;
  locale: string;
}

const EquipmentsReceipt: FC<EquipmentsReceiptProps> = ({
  equipment,
  locale,
}) => {
  const qty = equipment.quantity ?? 1;
  const total = equipment.price * qty;
  return (
    <tr className="text-[18px] font-normal border-b border-gray-100">
      <td className="py-2 pr-4">
        <div>{equipment.name[locale]}</div>
        {equipment.description[locale] && (
          <div className="text-[14px] text-gray-400">
            {equipment.description[locale]}
          </div>
        )}
      </td>
      <td className="py-2 pr-4 text-right">{qty}</td>
      <td className="py-2 pr-4 text-right">{equipment.price},-</td>
      <td className="py-2 text-right">{total},-</td>
    </tr>
  );
};

export default EquipmentsReceipt;
